module.exports = __webpack_public_path__ + "static/media/placeholder.1e87eff3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/placeholder.png
// module id = 120
// module chunks = 0